<template>
    <div class="container">
        <h1>About</h1>
        <p>
            Icons currently loaded from version <strong>Eq-IcoMoon-Library-0319-v2.4</strong> and are available for use
            within <strong>AEM</strong>.
        </p>
        <p>
            The IcoMoon icons are pulled from the CSS styles that exist on the marketing website. It saves them to your
            browser's cache for "quick" reuse, there are over 400 icons, so quick may be relative.
        </p>
        <router-link to="/"><i class="eq-icon eq-icon-home"></i> Home</router-link>
    </div>
</template>

<style lang="scss" scoped>
a {
    color: inherit;
}
</style>
